import * as React from "react";
import { LegalPage } from "@/components/LegalPage";
import { PRIVACY_SECTIONS, PRIVACY_UPDATED } from "@/constants/privacy";

export default function Datenschutz() {
  return (
    <LegalPage
      title="Datenschutzerklärung"
      meta={PRIVACY_UPDATED}
      sections={PRIVACY_SECTIONS}
    />
  );
}
